import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const WorkshopsPage = () => {
  const { theme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Acting Workshops | BookMyAudition</title>
      </Helmet>
      <div 
        className="workshops-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Exclusive Workshops
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Join interactive acting and casting workshops conducted by industry experts. Learn the craft and build your network.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <h3 className="fw-bold mb-3">Coming Soon</h3>
                <p className="mb-0 text-muted">
                  We are putting together a stellar lineup of mentors for our upcoming workshops. Check back later!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default WorkshopsPage;
